import locale from "@bonliva-crm/locale";
import { SingleSelect } from "@bonliva-crm/ui";
import { getSortOptionsNew } from "@search";
import { ComponentProps, useMemo } from "react";
import { useController, useFormContext } from "react-hook-form";
import { FilterWithFavouriteProps } from "../utils/filters-record-types";

type Option = { label: string; value: string };

export type SortFilterProps = { options?: Option[] } & FilterWithFavouriteProps;

export const SortFilter = ({ name, options }: SortFilterProps) => {
  const sortOptions = useMemo(() => options || getSortOptionsNew(), []);

  const { control, setValue } = useFormContext();
  const { field } = useController({
    name: name,
    control: control
  });

  const value = {
    label: sortOptions.find((option) => option.value === field?.value)?.label,
    value: field?.value
  };

  const commonProps: ComponentProps<typeof SingleSelect<Option>> = {
    options: sortOptions,
    name: name,
    value,
    onChange: (selected) => {
      setValue(name, selected.value, { shouldDirty: true });
    },
    hideSelectedOptions: false,
    controlShouldRenderValue: true,
    placeholder: locale.SortBy1,
    isSearchable: false,
    maxMenuHeight: 600,
    showBadge: false,
    optionType: "radio",
    isClearable: false,
    menuWidth: "240px",
    onClear: () => setValue(name, null, { shouldDirty: true })
  };

  return (
    <SingleSelect<Option>
      {...commonProps}
      styleProps={{
        control: { showBorder: true },
        menu: { showBorder: true }
      }}
    />
  );
};
